import React from 'react';
		
import { List, Edit, Filter, RefreshButton, Create, Datagrid, SimpleForm, required,
		TextField, BooleanField, NumberField, UrlField,DateField ,
		TextInput, DateInput, BooleanInput, NumberInput, SelectInput, ReferenceInput, LongTextInput, DisabledInput,
		EditButton, DeleteButton, ReferenceField  } from 'admin-on-rest';

import CHUrlField from '../utils/CHUrlField'
import CHEurField from '../utils/CHEurField'
import CHBoolField from '../utils/CHBoolField'
import { status_choices } from '../utils/enums' 
import RaisedButton from 'material-ui/RaisedButton';

import { CardActions, CardHeader, Card, CardText } from 'material-ui/Card';

import Createads from './Createads'
import ContentAdd from 'material-ui/svg-icons/content/add';
import ActionHelp from 'material-ui/svg-icons/action/help';
import { Link } from 'react-router-dom';
import ToggleAdStatsButton from './ToggleAdStatusButton';
import InlineEditButton from './InlineEditButton';
import CHDateInput from '../utils/CHDateInput';
import CHEurInput from '../utils/CHEurField';

const descriptionStyle = {
	display: 'block',	
	minHeight: 60,
	marginBottom: '15px',
}
const styles = {
	cardActions : {	padding: '10px' },
	raisedButton: { background: '#fd9512', color: '#fff', textTransform: 'upppercase' },
	descriptionCard: {marginBottom: '25px' },
	boldText: {fontWeight: 'bold'},
	primaryText: {color: '#284263'},
	actionHelp: {width: 35,height:35,color: '#ddd',marginTop: '5px'},
	leftDiv: {width: '5%',float:'left', textAlign:'center', paddingRight: '10px'},
	rightDiv: {width: '94%',float:'left'},
	row: {display: 'flex',flexWrap: 'wrap', color: '#676767',marginTop: '5px', lineHeight: '22px'},
	cardText: {padding: '10px 15px 5px 10px'},
	cardActionStyle: {paddingTop: '15px'},
	datagridStyles : {
		table: { },
		tbody: { },
		tr: { },
		header: {
			th: { padding: '5px 3px', color: '#516987', textTransform: 'lowercase'  },
			'th:first-child': {padding: '5px 3px', color: '#516987'  }, // special style for the first header column
		},
		cell: {
			td: { padding: '2px 19px' },
			'td:first-child': { padding: '2px 19px' }, // special style for the first column
		},
	},
	cardStyle: {padding:'10px',fontSize: '93%'},
	cardStyleTotal: {padding:'10px',fontSize: '93%',marginBottom:'15px', background: '#f3f3f3'},
	leftCol: { float: 'left', width: '40%'},
	rightCol: { float: 'left', width: '30%'},
	adRow: { clear:'both',display:'block',marginBottom:'5px'},
	clearer: {clear:'both',display:'block',padding: '2px',minHeight:'2px'},
	lightText: {color: '#999'},
	dateTextTop: {color: '#999', fontSize: '88%', display: 'inline-block', marginRight: '15px'}
}



/*
[{
   "id": 1,
   "ad_active": true,
   "ad_status": "In afwachting",
   "bid": 2,
   "bid_changed_on": "2018-04-04T15:00:00.000Z",
   "clicks": 5,
   "cloudhintsdomains_id": 1,
   "title": "vergelijk-boekhoudprogramma.nl",
   "website_url": "https://www.vergelijk-boekhoudprogramma.nl",
   "minimum_cpc": 1.5,
   "foo": "domain"
}]
*/


export const AdsEdit = (props) => (
 	<Edit title="Edit" {...props}>
        <SimpleForm>
            <strong>Algemeen</strong>
			<ReferenceField label="Adverteerder" source="user_id" linkType={false} reference="admin/customers">
                <TextField source="company_name" />
            </ReferenceField>
			
			<ReferenceField label="Domain" source="cloudhintsdomains_id" linkType={false} reference="admin/cloudhintsdomains">
                <TextField source="title" />
            </ReferenceField>
			
            <BooleanInput label="Actief?" source="ad_active" />
	        <BooleanInput label="Gebruiker mag bieden?" source="user_can_bid" />
			
			<span><br/><br/></span>
			<strong>Status</strong>
			
			<SelectInput source="ad_status" choices={status_choices} optionText="value" optionValue="value" />

			<span><br/><br/></span>
			<strong>Bieding</strong>
			<NumberInput source="bid" label="Bieding klant" />
			<BooleanInput label="Overschrijf CPC" source="use_admin_bid_for_order" />	
			<NumberInput source="admin_bid" label="Overschreven bieding" />
        </SimpleForm>
    </Edit>

)

export const AdsCreate = (props) => (
 	 <Create {...props}>
        <SimpleForm>
            <strong>Algemeen</strong>
			
			<ReferenceInput linkType={false} label="Advertisement" source="cloudhintsdomains_id" allowEmpty reference="admin/cloudhintsdomains">
                <SelectInput optionText="title" />
            </ReferenceInput>	
			<ReferenceInput linkType={false} label="Customer" source="user_id" allowEmpty reference="admin/customers">
                <SelectInput optionText="company_name" />
            </ReferenceInput>	
			
			
            <BooleanInput label="Actief?" source="ad_active" />
	        <BooleanInput label="Gebruiker mag bieden?" source="user_can_bid" />
			
			<span><br/><br/></span>
			<strong>Status</strong>
			
			<SelectInput source="ad_status" choices={status_choices} optionText="value" optionValue="value" />

			<span><br/><br/></span>
			<strong>Bieding</strong>
			<NumberInput source="bid" label="Bieding klant" />
			<BooleanInput label="Overschrijf CPC" source="use_admin_bid_for_order" />	
			<NumberInput source="admin_bid" label="Overschreven bieding" />
        </SimpleForm>
    </Create>

)

/*
  <TextField source="cloudhintsdomains.website_url" source_disp="cloudhintsdomains.title" label="Website" sortable={false} />
            <NumberField source="cloudhintsdomains.minimum_cpc" label="Min. CPC" source_disp="title" sortable={false} showTime />	
            
			<NumberField source="bid" label="Bieding (CPC) klant" sortable={false} />
			<BooleanField source="user_can_bid" label="User can bid?" sortable={false} />
	        <BooleanField source="use_admin_bid_for_order" label="Override bid?" sortable={false} />
	        <NumberField source="admin_bid" label="Override bid value" sortable={false} />
			
			<TextField className='adStatus' source="ad_status" label="Status plaatsing" sortable={false}  />	
	        
			<TextField source="cost" label="Kosten" sortable={false} />	
			<TextField source="avgcpc" sortable={false}  label="Gem. CPC" />	
			<TextField source="clickscalc" sortable={false}  label="Kliks" />		
			
			<EditButton />
			<DeleteButton />
			*/
const AdsGrid = ({ ids, data, basePath }) => (
    <div style={{ margin: '1em' }} className='adsGridAdmin'>
    {ids.map(id =>
        data[id].calc_row !== true ?
		
	
		<Card key={id} style={styles.cardStyle}>
            <span style={styles.leftCol} className='adsGridAdminCol1'>
				<span style={styles.adRow}>
					<strong>Adverteerder: </strong>
					
					<a href={`#/admin/customers/${data[id].user.id}`}>
								{data[id].user.company_name}
					</a>
				</span>
				
				<span style={styles.adRow}>
					<strong>Site: </strong>
					<a href={`#/admin/cloudhintsdomains/${data[id].cloudhintsdomains.id}`}>
								{data[id].cloudhintsdomains.title}
					</a> - <span style={styles.lightText}> € {data[id].cloudhintsdomains.minimum_cpc} </span>
				</span>
				
				<span style={styles.adRow}>
					<strong>Status: </strong>
					<TextField className='adStatus' record={data[id]} source="ad_status" label="" sortable={false}  />	
				</span>
				
				<span style={styles.adRow}>
					<strong>Actief: </strong>
					<CHBoolField source="ad_active" record={data[id]} label="" />		
				</span>
				
					
			</span>
			<span style={styles.rightCol} className='adsGridAdminCol2'>
			
				<span style={styles.adRow}>
					<strong>Gebruiker mag bieden? </strong>
					<CHBoolField source="user_can_bid" record={data[id]} label="" />		
				</span>
				
         		<span style={styles.adRow}>
					<strong>Bieding gebruiker: </strong>€ 
					<TextField  record={data[id]} source="bid" label="" sortable={false}  />	
				</span>
				
				<span style={styles.adRow}>
					<strong>Bonus bieding: </strong>€
					<NumberField record={data[id]} source="bonus_cpc_calc" label="" sortable={false}  />	
				</span>
				
				<span style={styles.adRow}>
					<strong>Overschreven bieding: </strong>
					<CHBoolField source="use_admin_bid_for_order" record={data[id]} label="" />	&nbsp;
					<CHEurField record={data[id]} source="admin_bid" label="" sortable={false}  />	
				</span>
		 	</span>
			
			<span style={styles.rightCol} className='adsGridAdminCol3'>
         		<span style={styles.adRow}>
					<strong>Kliks: </strong>
					 {data[id].clickscalc}
				</span>
				
				<span style={styles.adRow}>
					<strong>Kosten: </strong>
					 {data[id].cost}
				</span>
				<span style={styles.dateTextTop}>
					Gemaakt: <DateField record={data[id]} source="created_at" showTime />
				</span>
				<span style={styles.dateTextTop}>
					Bieding: <DateField record={data[id]} source="bid_changed_on" showTime />
				</span>
				<EditButton resource="ad" label="cloudhints.editad" basePath={basePath} record={data[id]} />
				<DeleteButton resource="ad" label="cloudhints.deletead" basePath={basePath} record={data[id]} />
			
		 	</span>
				
			<div style={styles.clearer}></div>
        </Card>
		
		: 
		
		<Card key={id} style={styles.cardStyleTotal}>
			<span style={styles.leftCol} className='adsGridAdminCol1'>
         		<span style={styles.adRow}>
					Let op: dit rapport is gelimiteerd op 100 advertenties. Dus de totalen zijn goed als je filtert op site of adverteerder maar niet als overall totaal. Gebruik daarvoor andere rapporten. 
				</span>
				<span style={styles.adRow}>
					<strong>Kliks: </strong>
					 {data[id].clickscalc}
				</span>
				
				<span style={styles.adRow}>
					<strong>Kosten: </strong>
					 {data[id].cost}
				</span>
				
				<span style={styles.adRow}>
					<strong>Gem. CPC: </strong>
					 {data[id].avgcpc}
				</span>
							
		 	</span>
				
			<div style={styles.clearer}></div>
        </Card>
		
	
		
    )}
    </div>
);
AdsGrid.defaultProps = {
    data: {},
    ids: [],
	_props: []
};

//<TextInput label="Search" source="q" alwaysOn /> defaultValue={new Date(Date.now())} 
const AdsFilter = (props) => (
    <Filter {...props} className="filter">
			
		
			
		<SelectInput source="ad_status" choices={status_choices} optionText="value" optionValue="value" alwaysOn />
		<ReferenceInput label="Adverteerder" source="user_id" linkType={false} reference="admin/customers" alwaysOn>
            <SelectInput optionText="company_name" />
        </ReferenceInput>
		<ReferenceInput label="Cloudhints site" source="cloudhintsdomains_id" linkType={false} reference="admin/cloudhintsdomains" alwaysOn>
            <SelectInput optionText="title" />
        </ReferenceInput>
		
		<DateInput source="to_date" label="Tot en met datum" alwaysOn options={{
				mode: 'portrait',
				hintText: 'Kies een t/m datum',
				okLabel: 'OK',
				cancelLabel: 'Cancel',
				locale: 'nl'
			}} />
			
		<DateInput source="initialfilter_from_date" label="Van datum" defaultValue={props.date} alwaysOn options={{
				mode: 'portrait',
				hintText: 'Kies een van datum',
				okLabel: 'OK',
				cancelLabel: 'Cancel',
				locale: 'nl',
			}} />
			
		
			
    </Filter>
);

export const AdsList = (props) => (
   <div className="list-con-lowercase">	
	<List className="list" {...props} perPage={50} title="Advertenties" filters={<AdsFilter date={new Date(new Date().getFullYear(), new Date().getMonth(), 1,0,0,0)} />} >
		<AdsGrid {...props} />
    </List>
	</div>
);


// WEBPACK FOOTER //
// ./src/admin_ads/Ads.js